import React from 'react';
import icon from 'resources/HOR-White_WCCdotcom.png';
import { Link } from 'react-router-dom';
import './LogoIcon.css';

function LogoIcon() {
  return (
    <div className="icon">
      <div className="logo">
        <Link to="/">
          <img src={icon} alt="Wind Creek Casino Logo" />
        </Link>
      </div>
    </div>
  );
}

export default LogoIcon;



// WEBPACK FOOTER //
// ./src/components/LogoIcon/index.js